import { render, staticRenderFns } from "./SteeringWheel.vue?vue&type=template&id=1dd289bd"
import script from "./SteeringWheel.vue?vue&type=script&lang=js"
export * from "./SteeringWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports